import { Auth0ProviderOptions } from '@auth0/auth0-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ApiAuthBridge } from './components/ApiAuthBridge'
import { Auth0ProviderWithNavigate } from './components/Auth0ProviderWithNavigate'
import { getConfig } from './configAuth'
import './index.css'
import { queryClient } from './queryClient'
import { deleteLegacyStorage } from './services/appPreferences/legacyStorageCleanup'

const config = getConfig(import.meta.env.VITE_ENV || import.meta.env.NODE_ENV)

const providerConfig: Auth0ProviderOptions = {
  domain: config.domain,
  clientId: config.clientId,
  ...(config.audience ? { audience: config.audience } : null),
  authorizationParams: {
    redirect_uri: window.location.origin + window.location.pathname,
  },
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')
const root = ReactDOM.createRoot(rootElement)
deleteLegacyStorage()
root.render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.PUBLIC_URL}>
      <Auth0ProviderWithNavigate config={providerConfig}>
        <QueryClientProvider client={queryClient}>
          <ApiAuthBridge />
          <App />
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>,
)
